import { Component, ViewChild } from '@angular/core';
import { AppSidebarMinimizerComponent } from '../app-sidebar-minimizer';
@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html'
})
export class AppSidebarComponent {
  isMinimizado;
  //@ViewChild(AppSidebarMinimizerComponent) sidebarMinimizer;

  ngAfterViewInit() {
    /*console.log(this.sidebarMinimizer);
    this.isMinimizado = this.sidebarMinimizer.isMinimizado;
    console.log(this.isMinimizado);*/
  }

  onPropagar(event:boolean){
    console.log(event);
    this.isMinimizado = event;
  }
 }



// WEBPACK FOOTER //
// /app/src/app/components/app-sidebar/app-sidebar.component.ts